module.exports = __webpack_public_path__ + "vue/img/icon-03.63dae427.png";